export const IconsFromInsert = {
  flow: 'y',
  gap: 'Z',
  position: 'relative',
  CaptionTitle: {
    width: '100%',
    Text: {
      text: '{{ editor.panel.icons | polyglot }}'
    },
    SearchButton: {
      extends: ['CanvasButton', 'IconButton'],
      icon: 'search',
      ariaLabel: (el) => el.call('polyglot', 'editor.insert.searchIcons'),
      margin: '- auto - A'
    },
    ExpandButton: {
      extends: ['CanvasButton', 'IconButton'],
      icon: 'expand',
      ariaLabel: (el) => el.call('polyglot', 'editor.insert.expandIcons'),
      onClick: (ev, el) => {
        el.setWindow('explorer', 'insert:icons')
      }
    },
    align: 'center'
  },
  IconsGroup: {
    limit: 96,
    childProps: {
      padding: 'auto',
      Icon: {
        fontSize: 'A'
      }
    }
  },
  InsertSectionShadow: {}
}
